// extracted by mini-css-extract-plugin
export default {"input":"calculatorInput_input__UEiCL","form":"calculatorInput_form__+ODUF","error":"calculatorInput_error__4NymQ"};